import { gql } from 'graphql-request'
import { useParams, Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import { Info as InfoIcon, Settings as SettingsIcon } from 'lucide-react'

import { useQuery } from '@hooks/graphql'
import Breadcrumbs from '@components/Breadcrumbs'
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"

import Overview from './Overview'
import Settings from './Settings'

const TUTOR_QUERY = gql`
  query tutor($id: ID!) {
    tutor(id: $id) {
      id
      name
      createdAt
      description
      summary
      socratic
      suggestionsEnabled
      stemModeEnabled
      knowledgeBaseEnabled
      visibility
      approvedForCommunity
      image {
        url
      }
      userName
      organizationName
    }
  }
`

const TutorDetails = () => {
  const { id, "*": splat } = useParams()
  const location = useLocation()
  const navigate = useNavigate()

  const previousListParams = location.state?.previousListParams || ''

  const { isLoading, refetch, data: { tutor = {} } = {} } = useQuery({
    queryKey: ['adminTutor', id],
    gqlQuery: TUTOR_QUERY,
    variables: { id }
  })

  if (isLoading) return

  let activeTab = 'overview'
  if (splat && splat.startsWith('settings')) {
    activeTab = 'settings'
  }

  const handleTabChange = (value) => {
    const path = value === 'overview' ? `/admin/tutors/${id}` : `/admin/tutors/${id}/${value}`
    navigate(path, { state: { previousListParams } })
  }

  return (
    <div>
      <Breadcrumbs>
        <Breadcrumbs.Link label='Tutors' to={`/admin/tutors${previousListParams}`} />
        <Breadcrumbs.Text label={tutor.name} />
      </Breadcrumbs>

      <Tabs value={activeTab} onValueChange={handleTabChange} className="m-5">
        <TabsList className="grid w-full grid-cols-2 md:w-[300px]">
          <TabsTrigger value="overview">
            <InfoIcon className='h-5 w-5 mr-2' />
            Overview
          </TabsTrigger>
          <TabsTrigger value="settings">
            <SettingsIcon className='h-5 w-5 mr-2' />
            Settings
          </TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="m-5">
        <Routes>
          <Route
            index
            element={
              <Overview
                tutorId={id}
                name={tutor.name}
                createdAt={tutor.createdAt}
                description={tutor.description}
                summary={tutor.summary}
                socratic={tutor.socratic}
                suggestionsEnabled={tutor.suggestionsEnabled}
                stemModeEnabled={tutor.stemModeEnabled}
                knowledgeBaseEnabled={tutor.knowledgeBaseEnabled}
                visibility={tutor.visibility}
                approvedForCommunity={tutor.approvedForCommunity}
                imageUrl={tutor?.image?.url}
                userName={tutor.userName}
                organizationName={tutor.organizationName}
              />
            }
          />

          <Route
            path='settings'
            element={
              <Settings
                tutorId={id}
                approvedForCommunity={tutor.approvedForCommunity}
                refetch={refetch}
              />
            }
          />
        </Routes>
      </div>
    </div>
  )
}

export default TutorDetails
